import React, { ElementType, forwardRef, ReactNode } from 'react';
import {
  ButtonProps,
  Button as ChakraButton,
  useStyleConfig,
} from '@chakra-ui/react';

type Variants =
  | `gray`
  | `solid`
  | `solidBlue`
  | `solidYellow`
  | `outline`
  | `round`
  | `outlineRed`
  | `outlineBlue`
  | `smallOutlineRed`
  | `smallOutlineBlue`
  | `blueProgress`
  | `lightBlue`
  | `redProgress`
  | `transparent`;

interface Props extends Omit<ButtonProps, `css`> {
  children?: ReactNode;
  as?: ElementType;
  variant?: Variants;
  isSuccess?: boolean;
  size?: `xs` | `sm` | `md` | `square`;
}

export const Button = forwardRef<HTMLButtonElement, Props>(
  (
    { children, as = `button`, variant, isSuccess, size, ...props },
    ref,
  ): JSX.Element => {
    const styles = useStyleConfig(`Button`, { size, variant });

    return (
      <ChakraButton as={as} ref={ref} __css={styles} type="button" {...props}>
        {children}
      </ChakraButton>
    );
  },
);

export type { Props as ButtonProps };
